/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import React, { memo, useState } from 'react';
import { Accordion, AccordionItem } from 'carbon-addons-iot-react';

const propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
};

const defaultProps = {
  isOpen: false,
  className: null,
};

/**
 * This is a wrapper component created to encapsulate Carbon's Accordion and AccordionItem into one
 * (and contain state)
 *
 * State: set state {open: true} to see the accordion open
 */
const AccordionSection = memo(({ title, children, className, isOpen }) => {
  const [open, setOpen] = useState(isOpen);

  const handleHeadingClick = () => {
    setOpen(!open);
  };

  return (
    <Accordion className={className}>
      <AccordionItem title={title} onHeadingClick={() => handleHeadingClick()} open={open}>
        {children}
      </AccordionItem>
    </Accordion>
  );
});

AccordionSection.propTypes = propTypes;
AccordionSection.defaultProps = defaultProps;
export default AccordionSection;
